import { GdprConsentString, CONFIG } from '@ecg-marktplaats/gdpr-consent-string';
import renderBanner from '../helpers/renderBanner';
import attachEventListeners from '../helpers/attachEventListeners';
import logGAEvent from '../helpers/logGAEvent';
import EVENT_ACTIONS from '../constants/EVENT_ACTIONS';
import shouldResurfaceBanner from '../helpers/shouldResurfaceBanner';

const initGDPRBannerV2 = async () => {
  const gdprConsentString = new GdprConsentString(CONFIG.TCF_VERSION);

  await gdprConsentString.init();

  if (!shouldResurfaceBanner(gdprConsentString) && gdprConsentString.isTCStringValid()) {
    /**
     * Returning the `gdprConsentString` for test assertion purposes
     */
    return gdprConsentString;
  }

  /**
   * Reset all user consent so we can start fresh
   */
  gdprConsentString.resetAllUserConsent();

  /**
   * Gets the CSS and Html markup for the banner and then appends
   * to document.body
   */
  renderBanner();

  /**
   * Log Banner Event Version
   */
  logGAEvent(EVENT_ACTIONS.BANNER_VERSION);

  /**
   * Banner has loaded
   */
  logGAEvent(EVENT_ACTIONS.CONSENT_BANNER_LOADED);

  /**
   * Sets up all the GA Tracking and binds the button event listeners
   */
  attachEventListeners(gdprConsentString);

  /**
   * Returning the `gdprConsentString` for test assertion purposes
   */
  return gdprConsentString;
};

export default initGDPRBannerV2;
